<template>
  <div class="footer">
    <div class="footer-top" v-if="!code">
      <div class="normal-footer" v-if="!taizhouFlag && !huangyanFlag && !haishuFlag">
        <div class="contact">
          <span>联系我们</span>
          <div class="contact-1">
            <img :src="footerPhone" class="mobile-content" />
            <img :src="phoneUrl" class="mobile" />
          </div>
          <div class="contact-2">
            <img :src="footerWx" class="wechat-content" />
            <img :src="wxUrl" class="wechat" />
          </div>
        </div>
        <div class="other">
          <span @click="toAboutUs">关于我们</span>
          <span @click="toEcologicalCooperation">生态合作</span>
          <span @click="toFutureStore">未来社区商店</span>
        </div>
      </div>
      
      <div class="taizhou-footer" v-if="taizhouFlag">
        <div>联系方式</div>
        <p>
          <span class="name">牵头单位：义乌市发展改革局</span>
        </p>
        <p>
          <span class="name">技术支持：浙江绿城未来数智科技有限公司</span>
          <span class="els">……</span>
          <span>
            <i class="tel-icon"></i>
            <span class="tel">0571-86885668</span>
          </span>
        </p>
      </div>
      <div class="taizhou-footer haishu-footer" v-if="haishuFlag">
        <div>联系方式</div>
        <p>
          <span class="name">宁波市海曙区住房和城乡建设局</span>
          <span>
            <i class="tel-icon"></i>
            <span class="tel"> 0574-83871441</span>
          </span>
        </p>
      </div>
      <div class="huangyan-footer" v-if="huangyanFlag">
        <div class="main">
          <div class="con-us">
            <span>联系我们</span>
            <span class="tel">0571-86885668</span>
          </div>
          <div class="other-nav">
            <span @click="developJoin">开发者入驻</span>
            <span @click="applicationCenter">应用能力中心</span>
            <span @click="documentCenter">文档中心</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom" v-if="!haishuFlag">
      <p>
        <span v-if="!code">Copyright © 2021 绿城理想生活服务集团有限公司 |</span>
        浙ICP备17022114号-1
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import phoneUrl from './assets/phone.png'
import wxUrl from './assets/wx.png'
import footerPhone from './assets/footer-mobile.png'
import footerWx from './assets/footer-wechat.png'
import envConfig from '../constants/env'
export default {
  data() {
    return {
      phoneUrl,
      wxUrl,
      footerPhone,
      footerWx,
      taizhouFlag: false,
      huangyanFlag: false,
      haishuFlag: false
    }
  },
  computed: {
    ...mapState({
      code: state => state.home.code
    })
  },
  watch: {
    '$route.query': {
      handler() {
        this.changeTotal()
      }
    }
  },
  methods: {
    toFutureStore() {
      const env = process.env.API_ENV || 'dev'
      const EnvVars = envConfig[env]
      window.open(EnvVars.futureUrl)
    },
    toEcologicalCooperation() {
      const env = process.env.API_ENV || 'dev'
      const EnvVars = envConfig[env]
      window.open(EnvVars.openUrl + 'partner', '_blank')
    },
    toAboutUs() {
      const env = process.env.API_ENV || 'dev'
      const EnvVars = envConfig[env]
      window.open(EnvVars.futureUrl + '/aboutUs')
    },
    // 开发者入驻
    developJoin() {
      window.open(
        'https://openplatform.gtdreamlife.com/#/partner/apply/application/level',
        '_target'
      )
    },
    // 应用能力中心
    applicationCenter() {
      window.open('https://openplatform.gtdreamlife.com/#/developer', '_target')
    },
    // 文档中心
    documentCenter() {
      window.open('https://openplatform.gtdreamlife.com/#/doc', '_target')
    },
    changeTotal() {
      const flag =
      (this.$route.query.taizhou && this.$route.query.taizhou === 'true') ||
        this.$route.meta.pageName === '台州专区'
      const flag2 =
        (this.$route.query.huangyan && this.$route.query.huangyan === 'true') ||
        this.$route.meta.pageName === '黄岩专区'
      const flag3 =
        (this.$route.query.yiwu && this.$route.query.yiwu === 'true') ||
        this.$route.meta.pageName === '义乌专区'
      const flag4 =
        (this.$route.query.haishu && this.$route.query.haishu === 'true') ||
        this.$route.meta.pageName === '海曙专区'
      this.taizhouFlag = flag || this.$route.query.tab === 'second' || flag3
      this.huangyanFlag = flag2 || this.$route.query.tab === 'second'
      this.haishuFlag = flag4
    }
  },
  mounted() {
    this.changeTotal()
  }
}
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  background: #000000;
  font-size: 20px;
  color: #fff;
  //底部-上部分
  .footer-top {
    width: 100%;
    display: flex;
    justify-content: space-around;
    color: #ffffff;
    border-bottom: 1px solid rgba(179, 179, 179, 0.6);
    .normal-footer {
      height: 133px;
      line-height: 133px;
      width: 100%;
      display: flex;
      justify-content: space-around;
    }
    .taizhou-footer {
      height: 265px;
      font-size: 20px;
      line-height: 1;
      text-align: center;
      & > div {
        margin-top: 26px;
        margin-bottom: 40px;
        font-size: 32px;
        font-weight: 600;
      }
      &.haishu-footer{
        height: 200px;
      }
      & > p {
        text-align: left;
        margin-bottom: 15px;
        .name {
          min-width: 450px;
          display: inline-block;
        }
        .els {
          display: inline-block;
          margin-right: 30px;
          color: #a2a2a2;
          font-size: 20px;
          position: relative;
          top: -5px;
        }
        span {
          .tel-icon {
            display: inline-block;
            width: 28px;
            height: 28px;
            background: url(../assets/image/detail/footer_tel.png);
            background-size: contain;
            position: relative;
            top: 5px;
            margin-right: 4px;
          }
          .tel {
            font-family: DINOT-Bold;
            font-weight: bold;
          }
        }
      }
    }
    .huangyan-footer {
      .main {
        height: 133px;
        display: flex;
        align-items: center;
        font-size: 20px;
        color: #fff;
        text-align: left;
        width: 1200px;
        .tel {
          font-family: DINOT-Bold;
          font-weight: bold;
          font-size: 30px;
          margin-left: 20px;
          position: relative;
          top: 4px;
        }
        .other-nav {
          margin-left: 382px;
          & > span {
            margin-left: 50px;
            cursor: pointer;
          }
        }
      }
    }
    .contact {
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        .mobile-content,
        .wechat-content {
          height: 0;
          width: 0;
        }
      }
      .contact-1 {
        &:hover {
          .mobile-content {
            position: absolute;
            width: 257px;
            height: 118px;
            left: 125px;
            bottom: 80px;
          }
        }
      }
      .contact-2 {
        &:hover {
          .wechat-content {
            position: absolute;
            width: 240px;
            height: 280px;
            left: 177px;
            bottom: 80px;
          }
        }
      }
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      .mobile,
      .wechat {
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
      span {
        width: 90px;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
        margin-right: 32px;
      }
      .mobile {
        margin-right: 32px;
      }
    }
    .other {
      span {
        width: 80px;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 28px;
        margin-right: 73px;
        cursor: pointer;
      }
      span:last-child {
        margin-right: 0;
      }
    }
  }
  //底部-下部分
  .footer-bottom {
    height: 69px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    p {
      margin: 23px auto;
      width: 600px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #989ca8;
      line-height: 22px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue